import axios from "axios";
import React, { useEffect, useState } from "react";
import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Table
} from "reactstrap";

import "../styles/ViewAllInvoiceSecurity.css";
import DashboardLayout from "../../src/components/DashboardLayout";

const getStatusLabel = (invoice) => {
    const raw = String(
        invoice.approvalStatus ??
        invoice.ApprovalStatus ??
        invoice.approvalStatusName ??
        invoice.statusName ??
        ""
    )
        .trim()
        .toLowerCase();

    if (raw === "3" || raw.includes("approv")) return "Approved";
    if (raw === "4" || raw.includes("reject")) return "Rejected";
    return "Pending";
};

const ViewAllInvoicesSecurity = () => {
    const [invoices, setInvoices] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showCard, setShowCard] = useState(false);

    const [selectedInvoice, setSelectedInvoice] = useState({
        approvalStatus: ""
    });

    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("details");
    const [comment, setComment] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");

    const [invoiceDetails, setInvoiceDetails] = useState({
        ApprovalStatus: "",
        Comments: ""
    });

    const [invoiceInfo, setInvoiceInfo] = useState(null);
    const [info, setinfo] = useState(null);
    const [VendorInfo, setVendorInfo] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [statusFilter, setStatusFilter] = useState("All");
    const [subTab, setSubTab] = useState("details");
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [historyData, setHistoryData] = useState([]);
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        AgreementDocument: "",
        EmailApproval: "",
        PO: "",
        Quotation1: "",
        Quotation2: "",
        PR: "",
        Invoice: "",
        ComparisonQuotes: ""
    });

    // Apply saved dark mode preference
    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);

    // Fetch security invoice list
    useEffect(() => {
        const fetchSecurityInvoices = async () => {
            try {
                const url = "/api/invoices/security-list";

                console.log("Calling API:", url);

                const response = await axios.get(url, {
                    params: {
                        statusId: 0,
                        search: ""
                    }
                });

                console.log("API status:", response.status);
                console.log("Full API response:", response.data);

                // Handle a direct array or an object containing the array.
                const data = response.data;
                const invoiceArray = Array.isArray(data)
                    ? data
                    : Array.isArray(data?.data)
                        ? data.data
                        : Array.isArray(data?.$values)
                            ? data.$values
                            : null;

                if (!invoiceArray) {
                    console.error(
                        "Expected an invoice array, received:",
                        data
                    );
                    setInvoices([]);
                    return;
                }

                console.log("Invoice count:", invoiceArray.length);
                console.log("First invoice:", invoiceArray[0]);

                setInvoices(invoiceArray);
            } catch (error) {
                console.error("Invoice API failed:", error.message);
                console.error("HTTP status:", error.response?.status);
                console.error("Backend response:", error.response?.data);

                setInvoices([]);
            }
        };

        fetchSecurityInvoices();
    }, []);
    // Fetch invoice approval history
    useEffect(() => {
        const invoiceId = selectedInvoice?.id ?? selectedInvoice?.ID;

        if (!invoiceId || !showModal) {
            return;
        }

        axios
            .get(`/api/invoices/approval-history/${invoiceId}`)
            .then((res) => {
                setHistoryData(res.data);
            })
            .catch((err) => {
                console.error(
                    "Error fetching invoice approval history:",
                    err
                );
                setHistoryData([]);
            });
    }, [
        activeTab,
        showModal,
        selectedInvoice?.id,
        selectedInvoice?.ID
    ]);

    // Fetch invoice information when the review modal opens
    useEffect(() => {
        const invoiceId = selectedInvoice?.id ?? selectedInvoice?.ID;

        if (!showModal || !invoiceId) {
            return;
        }

        axios
            .get(`/api/invoices/info/${invoiceId}`)
            .then((res) => {
                setInvoiceInfo(res.data);
            })
            .catch((err) => {
                console.error("Error fetching invoice info:", err);
                setInvoiceInfo(null);
            });
    }, [
        showModal,
        selectedInvoice?.id,
        selectedInvoice?.ID
    ]);

    // Update goods received list
    const updateGoodsList = (index, key, value) => {
        const updatedGoodsList = [
            ...(selectedInvoice.goodsList || [])
        ];

        updatedGoodsList[index] = {
            ...updatedGoodsList[index],
            [key]: value
        };

        setSelectedInvoice((prev) => ({
            ...prev,
            goodsList: updatedGoodsList
        }));
    };

    // Open invoice review modal
    const handleReviewClick = async (index) => {
        const selected = currentInvoices[index];

        console.log("Selected invoice:", selected);
        console.log(
            "InvoiceDownloadUrl:",
            selected?.InvoiceDownloadUrl
        );
        console.log("File name:", selected?.fileName);
        console.log(
            "All invoice fields:",
            Object.keys(selected || {})
        );

        if (!selected) {
            console.error("Selected invoice not found");
            return;
        }

        const invoiceId = selected.id ?? selected.ID;

        if (!invoiceId) {
            alert("Invoice ID is missing");
            return;
        }

        try {
            const [infoResponse, grnResponse] = await Promise.all([
                axios.get(`/api/invoices/info/${invoiceId}`),
                axios.get(`/api/invoices/grnitems/${invoiceId}`)
            ]);

            const goodsList = (
                Array.isArray(grnResponse.data)
                    ? grnResponse.data
                    : []
            ).map((item) => ({
                description: item.description ?? "",
                quantity: item.rcvQty ?? item.qty ?? "",
                unit: "",
                remarks: item.remark ?? ""
            }));

            // Populate invoice information and received goods
            setSelectedInvoice({
                ...selected,
                ...(infoResponse.data || {}),
                id: invoiceId,
                goodsList
            });

            setShowModal(true);
            setActiveTab("details");
            setApprovalStatusError("");
        } catch (error) {
            console.error("Failed API URL:", error.config?.url);
            console.error("HTTP status:", error.response?.status);
            console.error("Response data:", error.response?.data);
            console.error("Error message:", error.message);

            alert(
                "Unable to load invoice details. Check the browser console."
            );
        }
    };

    // Update vendor input
    const handleInputChange = (e, field) => {
        setSelectedVendor((prev) => ({
            ...prev,
            [field]: e.target.value
        }));
    };

    // Sort invoices by approval status
    const handleSort = (column) => {
        const sortedInvoices = [...invoices].sort((a, b) => {
            let valueA = "";
            let valueB = "";

            if (column === "approvalStatus") {
                valueA = String(a.approvalStatus ?? a.ApprovalStatus ?? "").toLowerCase();
                valueB = String(b.approvalStatus ?? b.ApprovalStatus ?? "").toLowerCase();
            }

            if (sortOrder === "asc") {
                return valueA.localeCompare(valueB);
            }

            return valueB.localeCompare(valueA);
        });

        setInvoices(sortedInvoices);
        setSortOrder((prev) =>
            prev === "asc" ? "desc" : "asc"
        );
        setSortBy(column);
    };

    // Filter invoices by approval status
    const invoicesPerPage = 6;

    const filteredInvoices = invoices.filter((invoice) => {
        if (statusFilter === "All") return true;
        return getStatusLabel(invoice) === statusFilter;
    });

    // Pagination
    const totalPages = Math.max(
        1,
        Math.ceil(filteredInvoices.length / invoicesPerPage)
    );

    const startIndex = (currentPage - 1) * invoicesPerPage;

    const currentInvoices = filteredInvoices.slice(
        startIndex,
        startIndex + invoicesPerPage
    );

    const handlePageChange = (action) => {
        if (action === "first") {
            setCurrentPage(1);
        } else if (action === "prev" && currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        } else if (
            action === "next" &&
            currentPage < totalPages
        ) {
            setCurrentPage((prev) => prev + 1);
        } else if (action === "last") {
            setCurrentPage(totalPages);
        }
    };

    // Handle file selection
    const handleFileChange = (e) => {
        const { name, files } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: files[0] || null
        }));
    };

    // Save invoice approval or rejection
    const handleSaveStatus = async () => {
        const newErrors = {};
        const check = (key, label) => {
            if (!String(selectedInvoice[key] ?? "").trim()) {
                newErrors[key] = `${label} is required.`;
            }
        };

        check("supplierName", "Supplier Name");
        check("grnNo", "GRN No");
        check("grnDate", "GRN Date");
        check("invoiceDate", "Invoice Date");
        check("poNo", "PO No");
        check("receivedBy", "Received By");
        check("preparedBy", "Prepared By");
        check("collectedBy", "Collected By");
        check("handoverTo", "Handover To");
        check("approvalStatus", "Approval Status");
        check("comments", "Comments");

        setErrors(newErrors);
        setApprovalStatusError(newErrors.approvalStatus || "");

        if (Object.keys(newErrors).length > 0) {
            return;
        }

        try {
            const invoiceId =
                selectedInvoice.id ?? selectedInvoice.ID;

            if (!invoiceId) {
                alert("Invoice ID is missing.");
                return;
            }

            const payload = {
                ID: invoiceId,
                ApprovalStatus: String(
                    selectedInvoice.approvalStatus
                ),
                Comments: selectedInvoice.comments,
                PreparedBy: selectedInvoice.preparedBy,
                ReceivedBy: selectedInvoice.receivedBy,
                CollectedBy: selectedInvoice.collectedBy,
                HandoverTo: selectedInvoice.handoverTo,
                GRNNo: selectedInvoice.grnNo,
                GRNDate: selectedInvoice.grnDate,
                DeliveryChallanNumber:
                    selectedInvoice.deliveryChallanNumber,
                UserId: localStorage.getItem("userId") || ""
            };

            const response = await fetch(
                "/api/invoices/save-review",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }
            );

            if (!response.ok) {
                alert(
                    "Failed to save: " + (await response.text())
                );
                return;
            }

            const result = await response.json();

            alert(result.message);
            setShowModal(false);

            // Refresh the security invoice list after saving
            const res = await axios.get("/api/invoices/security-list", {
                params: { statusId: 0, search: "" }
            });
            const d = res.data;
            setInvoices(
                Array.isArray(d) ? d
                    : Array.isArray(d?.data) ? d.data
                        : Array.isArray(d?.$values) ? d.$values
                            : []
            );
        } catch (error) {
            console.error(
                "Error saving invoice review:",
                error
            );

            alert(
                "An unexpected error occurred while saving."
            );
        }
    };

    return (
        <DashboardLayout>
            <div className="invoice-container">
                <h2 className="invoice-title">
                    Invoice Approval Details
                </h2>

                {/* Approval status filter */}
                <div
                    style={{
                        marginBottom: "15px",
                        width: "220px"
                    }}
                >
                    <label>
                        <strong>
                            Filter by Approval Status:
                        </strong>
                    </label>

                    <Input
                        type="select"
                        value={statusFilter}
                        onChange={(e) => {
                            setStatusFilter(e.target.value);
                            setCurrentPage(1);
                        }}
                    >
                        <option value="All">All</option>
                        <option value="Approved">Approved</option>
                        <option value="Pending">Pending</option>
                        <option value="Rejected">Rejected</option>
                    </Input>
                </div>

                {/* Invoice list */}
                <table className="invoice-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Company Name</th>
                            <th>Invoice Type</th>
                            <th>Invoice Number</th>
                            <th>Total Value</th>
                            <th>Create Date</th>

                            <th
                                onClick={() =>
                                    handleSort("approvalStatus")
                                }
                                style={{ cursor: "pointer" }}
                            >
                                Approval Status{" "}
                                {sortBy === "approvalStatus"
                                    ? sortOrder === "asc"
                                        ? "▲"
                                        : "▼"
                                    : "⇅"}
                            </th>

                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {currentInvoices.map((invoice, index) => (
                            <tr
                                key={
                                    invoice.id ??
                                    invoice.ID ??
                                    index
                                }
                            >
                                <td>{startIndex + index + 1}</td>

                                <td>
                                    {invoice.nameOfCompany}
                                </td>

                                <td>{invoice.invoiceType}</td>

                                <td>{invoice.invoiceNo}</td>

                                <td>
                                    {Number(
                                        invoice.totalValue ?? 0
                                    ).toLocaleString(undefined, {
                                        minimumFractionDigits: 2
                                    })}
                                </td>

                                <td>{invoice.createdDate}</td>

                                <td>
                                    {(
                                        invoice.approvalStatus ??
                                        invoice.ApprovalStatus
                                    ) || "Pending"}
                                </td>

                                <td>
                                    <button
                                        className="review-btn"
                                        onClick={() =>
                                            handleReviewClick(index)
                                        }
                                    >
                                        Review
                                    </button>
                                </td>
                            </tr>
                        ))}

                        {currentInvoices.length === 0 && (
                            <tr>
                                <td
                                    colSpan={8}
                                    style={{
                                        textAlign: "center"
                                    }}
                                >
                                    No invoices found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() =>
                            handlePageChange("first")
                        }
                        disabled={currentPage === 1}
                    >
                        First
                    </button>

                    <button
                        onClick={() =>
                            handlePageChange("prev")
                        }
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>

                    <span className="page-info">
                        Page {currentPage} of {totalPages}
                    </span>

                    <button
                        onClick={() =>
                            handlePageChange("next")
                        }
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>

                    <button
                        onClick={() =>
                            handlePageChange("last")
                        }
                        disabled={currentPage === totalPages}
                    >
                        Last
                    </button>
                </div>
            </div>

            {/* Invoice review modal */}
            <Modal
                isOpen={showModal}
                toggle={() => setShowModal(false)}
                centered
                size="xl"
            >
                <ModalHeader
                    toggle={() => setShowModal(false)}
                >
                    Invoice Details
                </ModalHeader>

                <div className="tabs1">
                    <span style={{ display: "none" }}>
                        Vendor Info
                    </span>

                    <span style={{ display: "none" }}>
                        Invoice Approval History
                    </span>

                    <span style={{ display: "none" }}>
                        Invoice Info
                    </span>

                    <span
                        className={
                            activeTab === "details"
                                ? "active-tab"
                                : ""
                        }
                        onClick={() =>
                            setActiveTab("details")
                        }
                    >
                        Approve/Reject
                    </span>
                </div>

                <ModalBody>
                    {(
                        activeTab === "details" ||
                        activeTab === "info" ||
                        activeTab === "history" ||
                        activeTab === "infoInvoice"
                    ) && (
                            <>
                                <Table
                                    bordered
                                    className="info-table1"
                                >
                                    <colgroup>
                                        <col
                                            style={{ width: "20%" }}
                                        />
                                        <col
                                            style={{ width: "30%" }}
                                        />
                                        <col
                                            style={{ width: "20%" }}
                                        />
                                        <col
                                            style={{ width: "30%" }}
                                        />
                                    </colgroup>

                                    <tbody>
                                        <tr>
                                            <th>
                                                <strong>
                                                    Name of Company:
                                                </strong>
                                            </th>

                                            <td colSpan={3}>
                                                {selectedInvoice?.nameOfCompany ||
                                                    "N/A"}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                <strong>
                                                    Supplier Name:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.supplierName ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            supplierName:
                                                                e.target.value
                                                        })
                                                    }
                                                    placeholder="Enter"
                                            />
                                            {errors.supplierName && <div className="text-danger">{errors.supplierName}</div>}
                                            </td>

                                            <td
                                                style={{
                                                    width: "30%",
                                                    minWidth: "220px"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection:
                                                            "column",
                                                        alignItems:
                                                            "flex-start",
                                                        gap: "8px",
                                                        minWidth: 0
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            whiteSpace:
                                                                "nowrap",
                                                            overflow:
                                                                "hidden",
                                                            textOverflow:
                                                                "ellipsis",
                                                            maxWidth:
                                                                "100%",
                                                            display: "block"
                                                        }}
                                                        title={
                                                            selectedInvoice?.fileName ||
                                                            selectedInvoice?.FileName ||
                                                            ""
                                                        }
                                                    >
                                                        {selectedInvoice?.fileName ||
                                                            selectedInvoice?.FileName ||
                                                            "Invoice file"}
                                                    </span>

                                                    <Button
                                                        type="button"
                                                        color="primary"
                                                        size="sm"
                                                        disabled={
                                                            !selectedInvoice?.invoiceFilePath
                                                        }
                                                        onClick={() => {
                                                            window.open(
                                                                selectedInvoice.invoiceFilePath,
                                                                "_blank",
                                                                "noopener,noreferrer"
                                                            );
                                                        }}
                                                    >
                                                        View
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                <strong>GRN No:</strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.grnNo ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            grnNo: e.target.value
                                                        })
                                                    }
                                                    placeholder="Enter"
                                            />
                                            {errors.grnNo && <div className="text-danger">{errors.grnNo}</div>}
                                            </td>

                                            <th>
                                                <strong>GRN Date:</strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                type="date"
                                                
                                                    value={
                                                        selectedInvoice?.grnDate ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            grnDate: e.target.value
                                                        })
                                                    }
                                            />
                                            {errors.grnDate && <div className="text-danger">{errors.grnDate}</div>}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                <strong>
                                                    Invoice No:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.invoiceNo ||
                                                        ""
                                                    }
                                                readOnly
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            invoiceNo:
                                                                e.target.value
                                                        })
                                                    }
                                                    placeholder="Enter"
                                                />
                                            </td>

                                            <th>
                                                <strong>
                                                    Invoice Date:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                type="date"
                                               
                                                    value={
                                                        selectedInvoice?.invoiceDate ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            invoiceDate:
                                                                e.target.value
                                                        })
                                                    }
                                            />
                                            {errors.invoiceDate && <div className="text-danger">{errors.invoiceDate}</div>}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                <strong>PO No:</strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.poNo ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            poNo: e.target.value
                                                        })
                                                    }
                                                    placeholder="Enter"
                                            />
                                            {errors.poNo && <div className="text-danger">{errors.poNo}</div>}
                                            </td>

                                            <th>
                                                <strong>DC No:</strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.deliveryChallanNumber ||
                                                        ""
                                                    }
                                                readOnly
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            deliveryChallanNumber:
                                                                e.target.value
                                                        })
                                                    }
                                                />
                                            </td>
                                        </tr>

                                        {/* Goods received details */}
                                        <tr>
                                            <td colSpan={4}>
                                                <div className="text-center mt-3 mb-2">
                                                    <strong>
                                                        The Following Goods
                                                        have been Received
                                                    </strong>
                                                </div>

                                                <table className="table table-sm table-bordered mt-2">
                                                    <thead>
                                                        <tr>
                                                            <th>S. No.</th>
                                                            <th>
                                                                Description
                                                                of Material
                                                            </th>
                                                            <th>Quantity</th>
                                                            <th>Unit</th>
                                                            <th>Remarks</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {(
                                                            selectedInvoice?.goodsList?.length >
                                                                0
                                                                ? selectedInvoice.goodsList
                                                                : [{}]
                                                        ).map(
                                                            (item, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        {index + 1}
                                                                    </td>

                                                                    <td>
                                                                        <Input
                                                                            type="text"
                                                                            value={
                                                                                item.description ||
                                                                                ""
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                updateGoodsList(
                                                                                    index,
                                                                                    "description",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            placeholder="Description"
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <Input
                                                                            type="number"
                                                                            value={
                                                                                item.quantity ??
                                                                                ""
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                updateGoodsList(
                                                                                    index,
                                                                                    "quantity",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            placeholder="Qty"
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <Input
                                                                            type="text"
                                                                            value={
                                                                                item.unit ||
                                                                                ""
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                updateGoodsList(
                                                                                    index,
                                                                                    "unit",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            placeholder="Unit"
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <Input
                                                                            type="text"
                                                                            value={
                                                                                item.remarks ||
                                                                                ""
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                updateGoodsList(
                                                                                    index,
                                                                                    "remarks",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            placeholder="Remarks"
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>

                                        {/* Received By and Prepared By */}
                                        <tr>
                                            <th>
                                                <strong>
                                                    Received By:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.receivedBy ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            receivedBy:
                                                                e.target.value
                                                        })
                                                    }
                                                    placeholder="By"
                                            />
                                            {errors.receivedBy && <div className="text-danger">{errors.receivedBy}</div>}
                                            </td>

                                            <th>
                                                <strong>
                                                    Prepared By:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.preparedBy ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            preparedBy:
                                                                e.target.value
                                                        })
                                                    }
                                                    placeholder="By"
                                            />
                                            {errors.preparedBy && <div className="text-danger">{errors.preparedBy}</div>}
                                            </td>
                                        </tr>

                                        {/* Collected By and Handover To */}
                                        <tr>
                                            <th>
                                                <strong>
                                                    Collected By:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.collectedBy ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            collectedBy:
                                                                e.target.value
                                                        })
                                                    }
                                                    placeholder="By"
                                            />
                                            {errors.collectedBy && <div className="text-danger">{errors.collectedBy}</div>}
                                            </td>

                                            <th>
                                                <strong>
                                                    Handover To:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td style={{ width: "30%" }}>
                                                <Input
                                                    type="text"
                                                    value={
                                                        selectedInvoice?.handoverTo ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            handoverTo:
                                                                e.target.value
                                                        })
                                                    }
                                                    placeholder="To"
                                            />
                                            {errors.handoverTo && <div className="text-danger">{errors.handoverTo}</div>}
                                            </td>
                                        </tr>

                                        {/* Approval status and comments */}
                                        <tr>
                                            <th>
                                                <strong>
                                                    Approval Status:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td>
                                                <Input
                                                    type="select"
                                                    value={
                                                        selectedInvoice?.approvalStatus ||
                                                        ""
                                                    }
                                                    onChange={(e) => {
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            approvalStatus:
                                                                e.target.value
                                                        });

                                                        setApprovalStatusError(
                                                            ""
                                                        );
                                                    }}
                                                >
                                                    <option value="">
                                                        Select
                                                </option>

                                                <option value="2">
                                                    Pending 
                                                </option>

                                                    <option value="3">
                                                        Approved
                                                    </option>

                                                    <option value="4">
                                                        Rejected
                                                    </option>
                                                </Input>

                                                {approvalStatusError && (
                                                    <div className="text-danger">
                                                        {
                                                            approvalStatusError
                                                        }
                                                    </div>
                                                )}
                                            </td>

                                            <th>
                                                <strong>
                                                    Comments:
                                                </strong>
                                                <span className="required-field">
                                                    *
                                                </span>
                                            </th>

                                            <td>
                                                <Input
                                                    type="textarea"
                                                    value={
                                                        selectedInvoice?.comments ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedInvoice({
                                                            ...selectedInvoice,
                                                            comments:
                                                                e.target.value
                                                        })
                                                    }
                                                    placeholder="Enter your comment..."
                                            />
                                            {errors.comments && <div className="text-danger">{errors.comments}</div>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>

                                <ModalFooter>
                                    <Button
                                        color="success"
                                        onClick={handleSaveStatus}
                                    >
                                        Save
                                    </Button>

                                    <Button
                                        color="danger"
                                        onClick={() =>
                                            setShowModal(false)
                                        }
                                    >
                                        Close
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                </ModalBody>
            </Modal>
        </DashboardLayout>
    );
};

export default ViewAllInvoicesSecurity;